import React from 'react';
import * as moment from 'moment';

const FoodIntakeHeader = (props) => {
  const {mealsPerDay, perDay, columns} = props;

  let dayDates = [];

  for (let i = 0; i <= columns.length - 1; i++) {
    dayDates.push(moment().add(i, 'days').format('DD/MM/YYYY'));
  }

  return (
    <tr>
      <td className="nppe2-fc-feeding-guidelines-food-intake__table-header">
        {mealsPerDay} {perDay}
      </td>

      {columns.map((value, index)  => (
        <td
          key={index}
          className="nppe2-fc-feeding-guidelines-food-intake__table-header">
          {value} {dayDates[index]}
        </td>
      ))}

    </tr>
  );
}

export default FoodIntakeHeader;
